/**
 * @Author: DKing
 * @Desc: 业务常量
 * @Date: 2019-07-22
 */

/**
 * piker
 * 时间选择器配置参数 - 开始到结束，包含了最近时间选项
 * */
export const PICKER_DATE_BETWEEN_OPTIONS = {
  type: "daterange",
  typeTimer: "datetimerange", // 显示类型-具体到时分秒
  editable: true,
  unlinkPanels: true,
  rangeSeparator: "至",
  startPlaceholder: "开始日期",
  endPlaceholder: "结束日期",
  valueFormat: "yyyy-MM-dd",
  align: "left",
  pickerOptions: {
    shortcuts: [
      {
        text: "最近一周",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "最近一个月",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "最近三个月",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit("pick", [start, end]);
        }
      }
    ]
  }
};

/**
 * piker
 * 时间选择器配置参数 - 时间点
 * */
export const PICKER_DATE_POINT_OPTIONS = {
  // align: "right",
  type: "date",
  placeholder: "选择日期",
  pickerOptions: {
    disabledDate(time) {
      return time.getTime() > Date.now();
    }
    // shortcuts: [{
    //   text: '今天',
    //   onClick(picker) {
    //     picker.$emit('pick', new Date());
    //   }
    // }, {
    //   text: '昨天',
    //   onClick(picker) {
    //     const date = new Date();
    //     date.setTime(date.getTime() - 3600 * 1000 * 24);
    //     picker.$emit('pick', date);
    //   }
    // }, {
    //   text: '一周前',
    //   onClick(picker) {
    //     const date = new Date();
    //     date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
    //     picker.$emit('pick', date);
    //   }
    // }]
  }
};

/**
 * pagination
 * 分页器配置参数
 * */
export const PAGINATION = {
  background: true,
  layout: "total, prev, pager, next, jumper",
  layPagesChange: "total, sizes, prev, pager, next, jumper",
  middleLayout: "total, prev, pager, next",
  pageSize: 20,
  pageSize10: 10,
  pageSize8: 8,
  pageSize5: 5,
  pageSizes: [20, 50, 100, 200],
  pageSizesAdd: [20, 50, 100, 200, 500, 1000],
  pageSizeEight: [8, 20, 50, 100, 200]
};

/**
 * consts
 * 页面常量结合
 * */
export const CONSTS = {
  tableMaxHeight: 1600, // table的最大高度
  tdMaxWidth: 250,
  tdMaxWidthSmall: 150,
  tableEmptyText: "暂无数据"
};

/**
 * form
 * form表单常用常量
 * */
export const FORMS = {
  labelMaxWidth: "140px",
  labelMinWidth: "72px",
  labelMiddleWidth: "100px",
  labelWidth121: "121px"
};

/**
 * table 常用常量
 * */
export const TABLE_CONST = {
  maxHeight: 1600,
  tdMaxWidth: 300
};

/**
 * th,td
 * th,td表格宽度常量
 * */
export const TABLE_COMMENT_WIDTH = {
  tableWidthMiddle: "176px",
  tableWidthMax: "200px",
  tableWidthMax400: "400px",
  tableWidthMax300: "300px",
  tableWidthMax250: "250px",
  tableWidthSmall: "150px",
  tableWidth100: "100px",
  tableWidth55: "55px"
};

/**
 * dialog 含有form表单常用常量
 * */
export const DIALOG_CONST = {
  labelWidth: "120px"
};

/**
 * billingStatus 开票状态
 * */
export const BILLING_STATUS_CONST = [
  // {value:'10',label:'未开票'},
  // {value:'35',label:'部分已开票'},
  // {value:'40',label:'驳回'},
  // {value:'60',label:'已销'}
  { value: "20", label: "开票处理中" },
  { value: "30", label: "开票成功" },
  { value: "40", label: "开票失败" },
  { value: "95", label: "已作废" }
];

/**
 * processingState 处理状态筛选条件
 * */
export const PROCESSING_STATE_CONST = [
  { value: 20, label: "加款成功" },
  { value: 30, label: "挂账" }
];

/**
 * processingState 处理状态-列表返回字段，对应类名
 * 33: 审批中
34: 审批拒绝
35: 审批通过
 * */
export const PROCESSING_STATE_OBJ = [
  { value: -10, label: "加款失败", className: "point-red" },
  { value: 11, label: "未分配", className: "point-orange" },
  { value: 13, label: "调拨中", className: "point-orange" },
  { value: 20, label: "加款成功", className: "point-green" },
  { value: 30, label: "挂账", className: "point-orange" },
  { value: 33, label: "处理中", className: "point-orange" },
  { value: 34, label: "审批拒绝", className: "point-red" },
  { value: 35, label: "审批通过", className: "point-green" },
  { value: 40, label: "已撤销", className: "point-gary" },
  { value: 52, label: "退款待确认", className: "point-orange" },
  { value: 53, label: "退款处理中", className: "point-orange" },
  { value: 60, label: "退款成功", className: "point-green" },
  { value: 61, label: "退款失败", className: "point-red" }
];

/**
 * validating 开票类型
 * */
export const INVOIC_TYPE_ARRAY = [
  { value: "10", label: "普通发票" },
  { value: "20", label: "增值税专用发票" }
];

/**
 * invoiceFileFormat 电子发票格式
 * */
export const INVOICE_FILE_FORMAT = [
  { value: 1, label: "PDF格式" },
  { value: 2, label: "OFD格式" },
  { value: 3, label: "XML格式" },
  { value: 4, label: "OFD+XML格式" },
  { value: 5, label: "PDF+XML格式" }
];

/**
 * 商户类型 - 商户管理
 * */
export const MERCHANT_TYPE_STATUS = [
  { key: "10", value: "10", label: "集团商户" },
  { key: "20", value: "20", label: "集团子公司" },
  { key: "30", value: "30", label: "普通商户" },
  { key: "40", value: "40", label: "代理" }
];

/**
 * 任务平台
 * */
// 任务类型
export const TASK_TYPE = [
  { value: 1, label: "公共任务" },
  { value: 2, label: "专属任务" }
];

// 紧急程度
export const TASK_EMERGENCY_LEVEL = [
  { value: 1, label: "急聘" },
  { value: 2, label: "正常" }
];

// 证件类型
export const IDCARD_TYPE = [
  { value: 1, key: 1, label: "身份证" },
  { value: 2, key: 2, label: "港澳居民来往内地通行证" },
  { value: 5, key: 5, label: "台湾居民来往大陆通行证" },
  { value: 3, key: 3, label: "外国护照" },
  { value: 6, key: 6, label: "中华人民共和国港澳居民居住证" },
  { value: 7, key: 7, label: "中华人民共和国台湾居民居住证" }
  // { value: 4, key: 4, label: "军官证" }
];

// 在职状态
export const INSURE_WORKERS_STATUS = [
  { value: 1, label: "在职" },
  { value: 0, label: "离职" }
];

// 学历要求列表
export const EDUCATION_lIST = [
  {
    key: "学历不限",
    value: "学历不限"
  },
  {
    key: "初中及以上",
    value: "初中"
  },
  {
    key: "高中及以上",
    value: "高中"
  },
  {
    key: "专科及以上",
    value: "专科"
  },
  {
    key: "本科及以上",
    value: "本科"
  },
  {
    key: "硕士及以上",
    value: "硕士"
  },
  {
    key: "博士",
    value: "博士"
  }
];

// 计费单位列表
export const UNIT_lIST = [
  { unit: "日", className: "unit-item " },
  { unit: "月", className: "unit-item " },
  { unit: "小时", className: "unit-item " },
  { unit: "次", className: "unit-item " },
  { unit: "个", className: "unit-item " },
  { unit: "件", className: "unit-item " }
];

// 性别要求
export const GENDER_STATUS = [
  { value: "0", label: "男女不限" },
  { value: "1", label: "男" },
  { value: "2", label: "女" }
];

// 申请状态 - 个体工商户
export const APPLY_STATUS_LIST = [
  { value: 0, label: "未申请" },
  { value: 1, label: "待政府审核" },
  { value: 2, label: "申请通过" },
  { value: 3, label: "申请失败" },
  { value: 4, label: "ocr验证成功" },
  { value: 5, label: "实名认证成功" },
  { value: 6, label: "活体检测成功" },
  { value: 7, label: "待企业审核" }
];

// 订单状态 - 个体户订单管理
export const PERSONAL_ORDER_STATUS = [
  { value: "-4", label: "已退款" },
  { value: "-3", label: "退款中" },
  // {value: "-2", label: '已取消'},
  { value: "-1", label: "支付失败" },
  // {value: "0", label: '提交订单'},
  { value: "1", label: "未支付" },
  { value: "2", label: "支付中" },
  { value: "3", label: "支付成功" }
];

// 操作类型
export const OPERA_TYPE_STATUS = [
  { value: "10", label: "加款" },
  { value: "20", label: "扣款" },
  { value: "30", label: "退款" },
  { value: "31", label: "退票" },
  // { value: "60", label: "垫付资金" },
  // { value: "70", label: "垫资还款" },
  { value: "-20", label: "原路退账" },
  { value: "-30", label: "扣减" },
  // {value: "50", label: '更新'},
  // {value: "40", label: '冻结'},
  // {value: "-10", label: '退账'},
  { value: "32", label: "先征后返" },
  { value: "33", label: "返现扣款" },
  { value: "34", label: "跨阶梯管理费退还" }
];

/**
 * 新网-共管户
 */
// 新网账户管理- 交易类型
export const TRANSACATION_TYPE_LIST = [
  { value: "1", label: "线下" },
  { value: "2", label: "线上" }
];

// 保险垫资 - 经代 - 垫资状态
export const JD_ADVANCE_STATUS = [
  { value: "10", label: "未申请" },
  { value: "20", label: "待打款" },
  { value: "30", label: "垫资成功" }
];

// 保理 - 共管户状态
export const GGH_STATUS_LIST = [
  { value: 1, label: "开通成功" },
  { value: 2, label: "开通失败" }
];
// 用工中心
/**
 * 用工中心
 * */
// 结算周期
export const TASK_CYCLE = [
  { value: 1, label: "日结" },
  { value: 2, label: "周结" },
  { value: 3, label: "月结" }
];

// 任务说明书 - 签署状态
export const SIGN_STATUS_LIST = [
  { value: 1, label: "已签署" },
  { value: 0, label: "未签署" }
];

// 任务说明书 - 证件类型
export const ID_CARD_TYPE_LIST = [
  { value: 1, label: "身份证" },
  { value: 2, label: "港澳居民来往内地通行证" },
  { value: 5, label: "台湾居民来往大陆通行证" },
  { value: 6, label: "中华人民共和国港澳居民居住证" },
  { value: 7, label: "中华人民共和国台湾居民居住证" }
];

// 任务状态
export const POSITION_STATUS = [
  { value: "10", label: "上线" },
  { value: "20", label: "下线" }
];
// 结算状态 - 结算单
export const SETTLEMENT_STATUS = [
  { value: "10", label: "待提交", className: "point-orange" },
  { value: "11", label: "已取消", className: "point-gary" },
  { value: "20", label: "待结算", className: "point-orange" },
  { value: "30", label: "处理中", className: "point-orange" },
  { value: "40", label: "全部结算成功", className: "point-green" },
  { value: "50", label: "部分结算成功", className: "point-orange" },
  { value: "60", label: "全部结算失败", className: "point-red" }
];
// 结算状态 - 风控结算单
export const RISK_SETTLEMENT_STATUS = [
  { value: "20", label: "待结算", className: "point-orange" },
  { value: "40", label: "结算成功", className: "point-green" }
];
// 网商公管户 - 结算状态 - 结算单
export const SETTLEMENT_STATUS_WS = [
  { value: "10", label: "待确认", className: "point-orange" },
  { value: "11", label: "已取消", className: "point-gary" },
  { value: "20", label: "待打款", className: "point-orange" },
  { value: "30", label: "处理中", className: "point-orange" },
  { value: "40", label: "全部打款成功", className: "point-green" },
  { value: "50", label: "部分打款成功", className: "point-orange" },
  { value: "60", label: "全部打款失败", className: "point-red" }
];
// 网商公管户 - 制单状态
export const DOCUMENT_STATUS_WS = [
  // {value: "9", label: '无需制单', className:'point-gary'},  // 展示无意义，勿删
  { value: "10", label: "待制单", className: "point-orange" },
  // {value: "20", label: '提交制单', className:'point-orange'},  // 展示无意义，勿删
  { value: "30", label: "制单中", className: "point-orange" },
  { value: "40", label: "制单成功", className: "point-green" },
  { value: "50", label: "制单失败", className: "point-red" }
];

// 校验状态 - 结算单详情
export const SETTLEMENT_VERIFY_STATUS = [
  { value: "9", label: "校验中", className: "point-orange" },
  { value: "10", label: "初验成功", className: "point-green" },
  { value: "20", label: "验证失败", className: "point-red" },
  { value: "30", label: "已取消", className: "point-gary" },
  { value: "40", label: "待结算", className: "point-orange" },
  { value: "50", label: "结算中", className: "point-orange" },
  { value: "60", label: "结算成功", className: "point-green" },
  { value: "70", label: "结算失败", className: "point-red" },
  { value: "75", label: "已退款", className: "point-red" },
  { value: "90", label: "已退票", className: "point-red" }
];

// 用工中心 - 收款渠道
export const RECEIPT_CHANNEL_TYPE = [
  { value: "10", label: "银行卡" },
  { value: "20", label: "支付宝" },
  // 雪哥让加 渠道 -- 通联客户号 11-10 ljl修改
  { value: "50", label: "通联客户号" }
];

// 网商智能存管 - 制单状态
export const VOUCHER_PERPARATION_STATUS = [
  // { value: "9", label: "无需制单" },
  { value: "10", label: "待制单" },
  { value: "20", label: "提交制单" },
  { value: "30", label: "制单中" },
  { value: "40", label: "制单成功" },
  { value: "50", label: "制单失败" }
];

// 网商智能存管 - 订单状态
export const ONLINE_DRDER_STATUS = [
  { value: "10", label: "待确认" },
  { value: "11", label: "已取消" },
  { value: "20", label: "待打款" },
  { value: "30", label: "处理中" },
  { value: "40", label: "全部打款成功" },
  { value: "50", label: "部分打款成功" },
  { value: "60", label: "全部打款失败" }
];

//自由职业者列表 - 签约状态
export const SIGN_STATUS = [
  { value: "-1", label: "签约失败" },
  { value: "0", label: "待签约" },
  { value: "1", label: "任务待领取" },
  { value: "2", label: "签约成功" },
  { value: "3", label: "待人工审核" },
  { value: "4", label: "签约失效" }
];

// 自由职业者列表 - 附件协议签署状态
export const ANNEX_SIGN_STATUS = [
  { value: "0", label: "未签署" },
  { value: "2", label: "已签署" }
];

//自由职业者列表 - 实名认证状态
export const CERTIFICATION_STATUS = [
  { value: "-1", label: "认证失败" },
  { value: "0", label: "未认证" },
  { value: "1", label: "认证成功" },
  { value: "4", label: "待审核" },
  { value: "2", label: "人脸识别成功" },
  { value: "5", label: "未识别" },
  { value: "3", label: "三要素认证成功" }
];

//自由职业者列表 - 人像照状态
export const PORTRAIT_PHOTOS_STATUS = [
  { value: "1", label: "已上传" },
  { value: "0", label: "未上传" }
];
//自由职业者列表 - 证件照的状态
export const ID_PHOTOS_STATUS = [
  { value: 1, label: "已上传" },
  { value: 2, label: "未上传" }
];

//自由职业者管理 - 实名状态(针对自由职业者)
export const REAL_NAME_STATUS = [
  { value: "0", label: "未认证" },
  { value: "1", label: "认证成功" },
  { value: "-1", label: "验证失败" },
  { value: "-2", label: "手机号重复" }
];

//录用状态
export const WORKES_STATUS = [
  { value: "0", label: "待录用" },
  { value: "1", label: "已录用" },
  { value: "2", label: "已拒绝" }
];

// 报名详情 -- 收款渠道（非智能存管）
export const COLLECTION_CHANNEL_STATUS = [
  { value: 10, label: "银行卡" },
  { value: 20, label: "支付宝（*等额提现到银行卡免服务费）" }
  // { value: "30", label: "微信" },
];

// 营业状态
export const BUSSINESS_TYPE = [
  { value: "0", label: "营业中" },
  { value: "-1", label: "注销中" },
  { value: "1", label: "已注销" }
];

// 结算单风控列表审核状态
export const AUDIT_STATUS = [
  { value: "0", label: "等待提交" },
  { value: "1", label: "等待审核" },
  { value: "2", label: "审核通过" },
  { value: "3", label: "审核失败" }
];

// 余额管理 -- 微信文案描述
export const WECHATPAYTEXT = [
  "WECHATPAY05",
  "WECHATPAY06",
  "WECHATPAY07",
  "WECHATPAY08",
  "WECHATPAY09",
  "WECHATPAY10"
];
// 'WECHATPAY02','WECHATPAY03','WECHATPAY04',

// 余额管理 -- 新网银行
// export const XWBANKINFO = ['WECHATPAY06','WECHATPAY05','WECHATPAY07','WECHATPAY08','WECHATPAY09','WECHATPAY10'];
// 'WECHATPAY02','WECHATPAY03','WECHATPAY04','XWBANK','XWBANK1',

//合规中心 -- 合规进度
export const COMPLIANCE_PROGRESS = [
  { value: "0", label: "待上传", className: "point-orange" },
  { value: "1", label: "待审核", className: "point-orange" },
  { value: "2", label: "已达标", className: "point-green" },
  { value: "3", label: "未达标", className: "point-red" }
];

//合规中心 -- 在职员工数量
export const COMPANY_EMPLOYEES_NUM = [
  { value: "1", label: "100人以内" },
  { value: "2", label: "100-500人" },
  { value: "3", label: "500-1000人" },
  { value: "4", label: "1000-5000人" },
  { value: "5", label: "5000人以上" }
];

//合规中心 -- 单月总下发额
export const TOTAL_MONTHLY_PAYMENT = [
  { value: "1", label: "50万以内" },
  { value: "2", label: "50-100万" },
  { value: "3", label: "100-500万" },
  { value: "4", label: "500-1000万" },
  { value: "5", label: "1000-2000万" },
  { value: "6", label: "2000-5000万" },
  { value: "7", label: "5000以上" }
];
//合规中心 -- 费用发放周期
export const EXPENSE_PELEASE_CYCLE = [
  { value: "1", label: "每周结算一次" },
  { value: "2", label: "每月计算一次" },
  { value: "3", label: "每月计算多次" },
  { value: "4", label: "每季度结算一次" },
  { value: "5", label: "每日计算一次" }
];

//合规中心 -- 真实性proofOfAuthenticity
export const PROOF_OF_AUTHEN_TICITY = [
  { value: true, label: "是" },
  { value: false, label: "否" }
];

// 开票记录 - 开票信息 - 开票类型
export const BILLING_INFO_TYPE = [
  { value: "10", label: "6%普票" },
  { value: "20", label: "6%专票" },
  { value: "30", label: "免税-普票" }
];

// 登录 - 非oem域名
export const NOT_OEM_LIST = [
  "local-web.hvyogo.com",
  "bweb.hvyogo.com",
  "web.hvyogo.com"
];

// 首页数据看板展示
export const MONEY_PARAMS_LIST = [
  {
    amount: "",
    jumpUrl: "/balanceManage",
    name: "可用余额（元）",
    bgOneStyle: { width: "22px", height: "22px", top: "28px", left: "19px" },
    bgTowStyle: { width: "16px", height: "16px", top: "25px", left: "15px" },
    bgOneUrl: "../../../static/home/icon_home_yue_up.png",
    bgTowUrl: "../../../static/home/icon_home_yue_down.png"
  },
  {
    dataType: 1,
    amount: "",
    jumpUrl: "/BusinessStatistics",
    name: "累计结算金额（元）",
    bgOneStyle: { width: "20px", height: "22px", top: "28px", left: "21px" },
    bgTowStyle: { width: "15px", height: "18px", top: "24px", left: "31px" },
    bgOneUrl: "../../../static/home/icon_home_jiesuan_up.png",
    bgTowUrl: "../../../static/home/icon_home_jiesuan_down.png"
  },
  {
    dataType: 2,
    amount: "",
    jumpUrl: "/rechargeRecord",
    name: "累计充值金额（元）",
    bgOneStyle: { width: "22px", height: "22px", top: "28px", left: "25px" },
    bgTowStyle: { width: "16px", height: "16px", top: "25px", left: "21px" },
    bgOneUrl: "../../../static/home/icon_home_chongzhi_up.png",
    bgTowUrl: "../../../static/home/icon_home_chongzhi_down.png"
  },
  {
    dataType: 4,
    amount: "",
    jumpUrl: "/billingRecordList",
    name: "可开票金额（元）",
    bgOneStyle: { width: "19px", height: "21px", top: "29px", left: "24px" },
    bgTowStyle: { width: "15px", height: "17px", top: "26px", left: "20px" },
    bgOneUrl: "../../../static/home/icon_home_fapiao_up.png",
    bgTowUrl: ""
  }
];

// 管理中心 - 帐户管理 - 数据权限
export const DATA_PERMISSIONS_LIST = [
  { value: 0, label: "仅见自己" },
  { value: 1, label: "可见全部数据" }
];

// 数据中心 -- 历史时间
export const TRADE_YEAR_LIST = [
  { value: "2019", label: "2019年" },
  { value: "2020", label: "2020年" },
  { value: "2021", label: "2021年" },
  { value: "2022", label: "2022年" },
  { value: "2023", label: "2023年" },
  { value: "2024", label: "2024年" },
  { value: "2025", label: "2025年" }
];

// 佣金结算订单 - 代理类型
export const AGENT_TYPE_LIST = [
  { value: 10, label: "个体户" },
  { value: 20, label: "企业" },
  { value: 30, label: "个人" }
];

// 佣金结算订单 - 结算状态
export const SETTLE_STATUS = [
  { value: 10, label: "待提现" },
  { value: 30, label: "提现中" },
  { value: 40, label: "全部提现成功" },
  { value: 50, label: "部分提现成功" },
  { value: 60, label: "全部提现失败" }
];

// 佣金结算订单 - 提现详情 - 结算状态
export const WITHDRAWAL_STATUS = [
  { value: 10, label: "待提现", className: "point-orange" },
  { value: 50, label: "提现中", className: "point-orange" },
  { value: 60, label: "提现成功", className: "point-green" },
  { value: 75, label: "提现失败", className: "point-red" },
  { value: 90, label: "提现失败退票", className: "point-red" }
];

// 优惠券管理 - 优惠券管理列表 - 优惠券状态
export const COUPON_STATUS = [
  { value: 1, label: "进行中", className: "point-orange" },
  { value: 2, label: "已截止", className: "point-red" },
  { value: 3, label: "已使用", className: "point-green" }
];

// 任务列表 - 批量邀请
export const WORKER_POSITION_STATUS = [
  { value: 0, label: "未报名", className: "point-orange" },
  { value: 1, label: "已报名", className: "point-green" }
];

// 董监高审核状态
export const REVIEW_STATUS = [
  { value: 1, label: "待审核" },
  { value: 2, label: "通过" },
  { value: 3, label: "未通过" }
];

// 佣金结算周期
export const COMMISSION_SETTLEMENT_CYCLE = [
  { value: "MONTH", label: "月结" },
  { value: "WEEK", label: "周结" },
  { value: "DAY", label: "日结" }
];

// 证明类文件 - 用途
export const PURPOSE_TYPE_LIST = [
  { value: 2, label: "办理银行卡业务" },
  { value: 1, label: "办理手机号业务" }
];

// 证件要求
export const REQUIREMENT_QUALIFICATION_TYPE = [
  { value: 10, label: "健康证" },
  { value: 30, label: "驾驶证" }
];

// 福利
export const BENEFITS_LIST = [
  "奖金激励",
  "有提成",
  "就近安排",
  "时间自由",
  "环境好",
  "员工餐",
  "时薪高"
];

// 商户任务标签枚举
export const POSITION_TAG_STATUS = [
  { value: 10, label: "骑手专区" },
  { value: 20, label: "餐饮专区" },
  { value: 30, label: "短期急聘" },
  { value: 40, label: "直营自招" },
  { value: 50, label: "严选日结" }
];

/**
 * validating 验证状态
 * */
export const VALIDATING_CONST = [
  { value: 10, label: "验证成功" },
  { value: 9, label: "待验证" },
  { value: 20, label: "验证失败" }
];



// WEBPACK FOOTER //
// ./src/service/businessConsts.js